import { FormGroup } from '@angular/forms';

export function GreaterThanValidator(controlName: string, matchingControlName: string, orEqual = false) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (null === control.value || null === matchingControl.value) {
            // control.setErrors(null); // FG: the control might have other errors than this one...
            if (control.errors) {
                delete control.errors['greaterThan'];
                if (Object.keys(control.errors).length === 0) {
                    control.setErrors(null);
                }
            }

            return;
        }

        // greater than or equal
        if (orEqual && control.value.startOf('day') < matchingControl.value.startOf('day')) {
            control.setErrors({ greaterThan: true });

            return;
        }

        // greater than
        if (!orEqual && control.value.startOf('day') <= matchingControl.value.startOf('day')) {
            control.setErrors({ greaterThan: true });

            return;
        }

        // control.setErrors(null); // FG: the control might have other errors than this one...
        if (control.errors) {
            delete control.errors['greaterThan'];
            if (Object.keys(control.errors).length === 0) {
                control.setErrors(null);
            }
        }
    };
}
